import { Injectable, inject } from '@angular/core';
import { LoadedEvent, TranslocoService } from '@jsverse/transloco';
import { filter, firstValueFrom, map } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class TranslocoUtilityService {
	private readonly translocoService = inject(TranslocoService);

	public async translationsLoaded(): Promise<true> {
		return firstValueFrom(
			this.translocoService.events$.pipe(
				filter((e) => e.type === 'translationLoadSuccess'),
				map(() => true),
			),
		);
	}

	public translationFallbackLoaded(): Promise<boolean> {
		return firstValueFrom(
			this.translocoService.events$.pipe(
				filter((event) => event.type === 'translationLoadSuccess'),
				map((event) => (event as LoadedEvent).wasFailure),
			),
		);
	}
}
